import { memo, ReactNode, useMemo, useRef, useState } from 'react'
import { ReactComponent as BarIcon } from './assets/k-bar.svg'
import { ReactComponent as CandlesIcon } from './assets/k-candles.svg'
import { ReactComponent as HollowIcon } from './assets/k-hollow_candles.svg'
import { ReactComponent as LineIcon } from './assets/k-line.svg'
import { ReactComponent as AreaIcon } from './assets/k-area.svg'
import { ReactComponent as BaselineIcon } from './assets/k-baseline.svg'
import { ReactComponent as HeikinIcon } from './assets/k-heikin_ashi.svg'
import { useChartType } from 'store/orderbook/hooks'
import { updateChartType } from 'store/orderbook/actions'
import { useAppDispatch } from 'store'
import { Fade } from '@mui/material'
import {
  CurrentChartType,
  ChartTypeContainer,
  ChartTypeMenu,
  ChartTypeItem,
} from './styles'
import { useOnClickOutside } from 'usehooks-ts'

export interface ChartTypeProps {
  name: string
  value: number
  icon: ReactNode
}

const chartTypeOptions: ChartTypeProps[] = [
  {
    name: 'Bars',
    value: 0,
    icon: <BarIcon />,
  },
  {
    name: 'Candles',
    value: 1,
    icon: <CandlesIcon />,
  },
  {
    name: 'Hollow Candles',
    value: 9,
    icon: <HollowIcon />,
  },
  {
    name: 'Line',
    value: 2,
    icon: <LineIcon />,
  },
  {
    name: 'Area',
    value: 3,
    icon: <AreaIcon />,
  },
  {
    name: 'Baseline',
    value: 10,
    icon: <BaselineIcon />,
  },
  {
    name: 'Heikin Ashi',
    value: 8,
    icon: <HeikinIcon />,
  },
]

const ChartTypeSelector = memo(() => {
  const dispatch = useAppDispatch()
  // const { isOpen, onClose, onToggle } = useDisclosure();
  const [isIn, setIsIn] = useState(false)

  const chartType = useChartType()

  const ref = useRef(null)

  useOnClickOutside(ref, () => setIsIn(false))

  const currentChart = useMemo(() => {
    return chartTypeOptions.filter((chart) => chart.value === chartType)[0]
  }, [chartType])

  return (
    <ChartTypeContainer ref={ref}>
      <CurrentChartType onClick={() => setIsIn(!isIn)}>
        {currentChart.icon}
      </CurrentChartType>
      <Fade in={isIn}>
        <ChartTypeMenu>
          {chartTypeOptions.map((chartItem) => {
            return (
              <ChartTypeItem
                key={chartItem.value}
                onClick={() => {
                  try {
                    window.tvWidget.activeChart().setChartType(chartItem.value)
                    dispatch(updateChartType(chartItem.value))
                    setIsIn(false)
                  } catch (error) {
                    console.log(error)
                  }
                  // setChartType(chartItem.value);
                  // onClose()
                }}
                className={chartItem.value === chartType ? 'active' : undefined}
              >
                {chartItem.icon}
                {chartItem.name}
              </ChartTypeItem>
            )
          })}
        </ChartTypeMenu>
      </Fade>
    </ChartTypeContainer>
  )
})

export default ChartTypeSelector
